export const i18n = {
    pay: 'Оплата',
    refund: 'Возврат'
}